import * as Models from "../../Models";
import * as Services from "../../Services"
import { Batch } from "../../Models/ManageBatches";

export class ManageBatchesCtrl {
    public batches: Models.ManageBatches.Batch.Batch[];
    public partners: Models.PartnerModel.IPartnerModel[];
    public newBatches: Array<Models.ManageBatches.Batch.Batch> = new Array<Models.ManageBatches.Batch.Batch>();
    private nextId: number = -1;

    public static $inject = ['$state','PartnerRetrievalService'];
        constructor(public $state: angular.ui.IStateService,
                    private partnerRetrievalService: Services.PartnerRetrievalService.IPartnerRetrievalService ) {
            this.getPartners();
            this.getBatches();
        }

        public getBatches = (): void => {
            this.batches = [
                {
                    id: 1,
                     name: 'batch name',
                     fromDate: new Date(),
                     toDate: new Date(),
                     partner: new Models.PartnerModel.PartnerModel('name', 'code'),
                     inUse: true
                 },
                 {
                    id: 2,
                     name: 'batch name 2',
                     fromDate: new Date(),
                     toDate: new Date(),
                     partner: new Models.PartnerModel.PartnerModel('name2', 'code'),
                     inUse: true
                 },
             ];
        }

        public getPartners = (): void => {
            this.partnerRetrievalService.getPartners()
                .then((partners: Models.PartnerModel.IPartnerModel[]) => { this.partners = partners; });
        }

        public addBatchEntry = (): void => {
            var newBatch = new Models.ManageBatches.Batch.Batch();
            var nextId = this.getNextId();
            newBatch.id = nextId;
            newBatch.inUse = false;

            this.newBatches.push(newBatch);
        }

        public submitNewBatch = (batch: Models.ManageBatches.Batch.Batch): void => {
            //submit batch to api client
            this.batches.push(batch);
            this.newBatches.splice(this.newBatches.indexOf(batch), 1);

            //refresh batch list upon successful submit
            //this.getBatches();
        }
        
        public cancelNewBatch = (batch: Models.ManageBatches.Batch.Batch): void => {
            this.newBatches.splice(this.newBatches.indexOf(batch), 1);
        }

        public isValid = (batch: Models.ManageBatches.Batch.Batch): boolean => {
            //Each partner can only have one active batch at a time
            //dates cannot overlap per partner
            return true;
        }

        private getNextId = (): number => {
            var nextId = this.nextId;
            this.nextId--;
            return nextId;
        }
}
